import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/input';
import { FormlyFieldTextArea } from '@ngx-formly/material/textarea';

@Component({
    selector: 'mutara-message',
    templateUrl: './message.component.html',
    styleUrl: './message.component.scss',
    providers: [
        { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: MessageComponent },
    ],
    standalone: false
})
export class MessageComponent extends FormlyFieldTextArea implements OnInit {
  ngOnInit() {
  }
  get maxCharacters() {
    return this.props?.maxLength ?? 0;
  }

  get charCount() {
    return this.formControl.value?.length ?? 0;
  }
}

